import React from "react";

/** Stroke icons for game controls (decorative: buttons carry their own labels). */
const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

type IconProps = { size?: number };

export const ChevronLeft = ({ size = 20 }: IconProps) => (
  <svg {...base} width={size} height={size} strokeWidth={2.75}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
export const ChevronRight = ({ size = 20 }: IconProps) => (
  <svg {...base} width={size} height={size} strokeWidth={3}>
    <polyline points="9 6 15 12 9 18" />
  </svg>
);
export const ChevronDown = ({ size = 20 }: IconProps) => (
  <svg {...base} width={size} height={size} strokeWidth={3}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
export const RotateIcon = ({ size = 20 }: IconProps) => (
  <svg {...base} width={size} height={size} strokeWidth={2.6}>
    <path d="M20 12a8 8 0 1 1-2.34-5.66" />
    <polyline points="20 4 20 9 15 9" />
  </svg>
);
export const HardDropIcon = ({ size = 20 }: IconProps) => (
  <svg {...base} width={size} height={size} strokeWidth={2.8}>
    <line x1="12" y1="3" x2="12" y2="15" />
    <polyline points="6 9 12 15 18 9" />
    <line x1="5" y1="20" x2="19" y2="20" />
  </svg>
);
export const PauseIcon = ({ size = 18 }: IconProps) => (
  <svg {...base} width={size} height={size} strokeWidth={3}>
    <line x1="9" y1="5" x2="9" y2="19" />
    <line x1="15" y1="5" x2="15" y2="19" />
  </svg>
);
export const RestartIcon = ({ size = 18 }: IconProps) => (
  <svg {...base} width={size} height={size} strokeWidth={2.5}>
    <path d="M4 12a8 8 0 1 0 2.34-5.66" />
    <polyline points="4 4 4 9 9 9" />
  </svg>
);
export const PlayIcon = ({ size = 18 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden>
    <polygon points="7 4 20 12 7 20" />
  </svg>
);
export const StarIcon = ({ size = 16 }: IconProps) => (
  <svg {...base} width={size} height={size} strokeWidth={2.5}>
    <polygon points="12 3 14.8 8.9 21 9.6 16.4 13.9 17.6 20 12 17 6.4 20 7.6 13.9 3 9.6 9.2 8.9" />
  </svg>
);
